import { render, staticRenderFns } from "./CasePending.vue?vue&type=template&id=6df20461&scoped=true&"
import script from "./CasePending.vue?vue&type=script&lang=js&"
export * from "./CasePending.vue?vue&type=script&lang=js&"
import style0 from "./CasePending.vue?vue&type=style&index=0&id=6df20461&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df20461",
  null
  
)

export default component.exports